import {
  useExternalContractsControllerGetContracts,
  useExternalContractsControllerGetContract,
  type ContractListResponseDto,
  type ContractResponseDto,
} from "@semo/api-contracts";

/**
 * @param previewData DEV 전용: 값이 있으면 API 대신 이 더미 데이터로 렌더링한다
 *                    (/dev/preview?tab=contracts). API 호출은 비활성화된다.
 */
export function useExternalContracts(previewData?: ContractListResponseDto[]) {
  const { data, isLoading, error, refetch } =
    useExternalContractsControllerGetContracts({
      query: { enabled: !previewData },
    });

  // The Orval hook returns the full response object wrapped in a UseQueryResult
  // data is ExternalContractsControllerGetContracts200 which extends BaseResponseDto
  // data.data is ContractListResponseDto[]

  const contracts: ContractListResponseDto[] = previewData ?? data?.data ?? [];

  return {
    contracts,
    isLoading: previewData ? false : isLoading,
    error: error
      ? (error as any).message || "계약 목록을 불러오는데 실패했습니다."
      : null,
    refetch,
  };
}

export function useExternalContractDetail(contractId: string | null) {
  const { data, isLoading, error, refetch } =
    useExternalContractsControllerGetContract(contractId!, {
      query: {
        enabled: !!contractId,
      },
    });

  const contractData: ContractResponseDto | null = data?.data || null;

  return {
    data: contractData,
    isLoading,
    error: error
      ? (error as any).message || "계약 정보를 불러오는데 실패했습니다."
      : null,
    refetch,
  };
}
